<template>
  <div>
    <div class="columns">
      <div class="column">
        <b-notification :closable="false">
          <b-collapse :open="false" aria-id="contentIdForA11y1">
            <template #trigger="props">
              <b-icon icon="filter" size="is-medium" type="is-black" />
              {{ $t('compTransitionMapsMain.filter') }}
              <b-icon :icon="props.open ? 'caret-down' : 'caret-up'"> </b-icon>
            </template>
            <br />
            <filter-items @filtered="filtered"></filter-items>
          </b-collapse>
        </b-notification>
      </div>
      <div class="column is-1">
        <b-button
          v-if="!fullscreen"
          icon-right="expand"
          @click="toggleFullscreen"
        />
        <b-button v-else icon-right="compress" @click="toggleFullscreen" />
      </div>
    </div>

    <b-tabs
      destroy-on-hide
      v-model="transitionStore.filterTab"
      @input="tabChanged"
    >
      <b-tab-item value="0" :label="$t('compTransitionMapsMain.tab-map')">
        <map-items
          :fullscreen="fullscreen"
          :items="items"
          :count="count"
          @onBoundsUpdated="boundsUpdated"
          @onOpenItem="openAction"
          @onClickFile="clickFile"
          @onLoadMore="loadMore"
        ></map-items>
      </b-tab-item>
      <b-tab-item value="1" :label="$t('compTransitionMapsMain.tab-table')">
        <table-items
          :fullscreen="fullscreen"
          :items="items"
          :count="count"
          @onOpenItem="openAction"
          @onClickFile="clickFile"
          @onLoadMore="loadMore"
        >
        </table-items>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import transitionService from '@/services/transitionService'
import { BackendFilter } from '@/mixins/backendfilter.js'
import { PublicAction } from '@/models/transition/transition'
import { useTransitionStore } from '@/stores/transition'
import { openFileAsync } from '../../../models/transition/utils'

import _ from 'lodash'

export default {
  name: 'Maps',
  components: {
    'map-items': () => import('./MapItems.vue'),
    'table-items': () => import('./TableItems.vue'),
    'filter-items': () => import('./FilterItems.vue')
  },
  props: {
    fullscreen: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [BackendFilter],
  data: function () {
    return {
      ItemClass: () => PublicAction,
      getNextFnc: (next) => transitionService.getNextPublishedActions(next),
      getItems: (filters) => transitionService.getPublishedActions(filters),
      openAction: (action) => {
        let route = this.$router.resolve({
          path: `/transition-1point5/public/actions/${action.id}`
        })
        window.open(route.href, '_blank')
      },
      clickFile: (file) => {
        if (file.url) {
          openFileAsync(transitionService.getFile(file), file.name)
        }
      }
    }
  },
  computed: {
    nLaboratories () {
      return _.uniq(this.items.map((d) => d.entity.id)).length
    }
  },
  setup () {
    const transitionStore = useTransitionStore()
    return { transitionStore }
  },
  methods: {
    tabChanged (value) {
      if (value === 1) {
        // reset bounds filtering
        this.resetBounds()
      }
    },
    toggleFullscreen () {
      if (!this.fullscreen) {
        /** we're in reduced format so make it fullscreen */

        this.$router.push({
          name: 'transition-1point5-actions-map-fullscreen'
        })
      } else {
        /** we're in fullscreen so make it reduced */
        this.$router.push({
          name: 'transition-1point5-named',
          params: { named: 'transition-maps' }
        })
      }
    }
  },
  mounted () {
    if (this.transitionStore.filterTab === 1) {
      // we land in the table directly, no filter will be trigger automagically
      // so forcing once note that if we land on the map tab, filter will be
      // applied because boundsChanged will be called.
      this.filterAll()
    }
  }
}
</script>
